import { render, staticRenderFns } from "./wikiHead.vue?vue&type=template&id=49c72a5d&"
import script from "./wikiHead.vue?vue&type=script&lang=js&"
export * from "./wikiHead.vue?vue&type=script&lang=js&"
import style0 from "./wikiHead.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LoginBox: require('/root/workspace/web-pclive_YcmS/components/login/loginBox.vue').default})
